import { create } from "zustand";

interface MarketingTermsAgreeState {
  pendingAgreeId: number | null;
  requestAgree: (termsId: number) => void;
  clear: () => void;
}

export const useMarketingTermsAgreeStore = create<MarketingTermsAgreeState>(
  (set) => ({
    pendingAgreeId: null,
    requestAgree: (termsId) => set({ pendingAgreeId: termsId }),
    clear: () => set({ pendingAgreeId: null }),
  }),
);
